module.exports = __webpack_public_path__ + "static/media/support.640cded8.png";